import React from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { reqEsOrderInfoAction, reqEsOrderCodeReset } from '../../modules/od/orderModule';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import Footer from '../../components/common/Footer';
import { useState } from 'react';
import EsOrderDonePayinfo from '../../components/es/EsOrderDonePayinfo';
import EsOrderDoneDvryInfo from '../../components/es/EsOrderDoneDvryInfo';
import EsOrderDoneProdInfo from '../../components/es/EsOrderDoneProdInfo';
import { isMobileOnly } from 'react-device-detect';
import { groupBy, forEach, remove, concat, findIndex, replace } from 'lodash';
import EsOrderDoneList from '../../components/od/EsOrderDoneList'
import * as F from '../../lib/util/CommonFunctions';
import moment from "moment";
import { setEsitemCurIdxAction } from '../../modules/es/esItemModule';
const EsOrderDoneBlock = styled.div`
    ${isMobileOnly ? `
    margin: 0 4vw;
    `
    : `
    width: 100%;
    margin: 0 auto;`};

    .green {
        color: #79b88a;
    }
`;

const EsOrderDoneContentsBlock = styled.div`
    ${isMobileOnly?`
    padding: 50px 0 0px;
         
    `:`
    padding: 60px 0 160px;
    width: 1176px;
    margin: 0 auto;
    `};
    

    .header {
        ${isMobileOnly?`
        font-size: 16px;
        height: 24px;
        line-height: 24px;
        margin-bottom: 20px;
        `:`
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        width: 100%
        `};

        font-weight: 500;
        text-align: left;
        color: #111111;
    }

    .line {
        height: 2px;
        background-color: #111111;
        margin-bottom: 30px;
    }

    .line2 {
        height: 1px;
        background-color: #cccccc;
    }

    .line-no-margin {
        height: 2px;
        background-color: #111111;
    }

    .container-content {
        ${isMobileOnly?`
        padding: 0 0;
        `:`
        padding: 0 37px;
        `};
        
    }

    .sub-title {
        ${isMobileOnly?`
        font-size: 13px;
        line-height: 1.29;
        float:left;
        `:`
        font-size: 14px;
        line-height: 1.2;
        `};
        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: left;
        color: #999999;
        width: 80px;
        margin-right: 20px;
        display: inline-block;
    }

    .sub-content {
        ${isMobileOnly?`
        font-size: 13px;
        line-height: 1.46;
        width: calc(92vw - 105px);
        float: left;
        `:`
        font-size: 14px;
        line-height: 1.2;
        `};
        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }
`;

const EsOrderDoneHeaderTitleMBlock = styled.div`
    width: 100vw;
      
    height: 50px;
    //margin: 0 0 30px;
    //padding: 7px 125px 7px 2px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 10;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #111111;
    line-height: 50px;
    margin-left: -4vw;
`;

const EsOrderDoneHeaderTitleMBtnBlock = styled.button`
    width: 36px;
    height: 36px;
    position: absolute;
    top: 7px;
    left: 2px;
    background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
`;

const EsOrderDoneHeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const EsOrderDoneHeaderBlock = styled.div`
    
    .complete-icon {
        ${isMobileOnly?`
        margin: 41px auto 0;
        width: 60px;
        height: 67px;
        background: url(/assets/images/icon/order_complete_small.svg) center center/auto no-repeat;
    
        `:`
        margin: 123px auto 0;
        width: 90px;
        height: 101px;
        background: url(/assets/images/icon/order_complete.svg) center center/auto no-repeat;
    
        `};

        object-fit: contain;
    }

    .complete-title {
        ${isMobileOnly?`
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.44;
        `:`
        font-size: 40px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        `};
        
        text-align: center;
        color: #111111;
    }

    .complete-sub {
        ${isMobileOnly?`
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.33;
        color: #666666;
        `:`
        line-height: 1.75;
        font-size: 16px;
        color: #333333;
        `};

        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: center;
        
    }

    .complete-num {
        ${isMobileOnly?`
        font-size: 12px;
        line-height: 2.33;
        `:`
        font-size: 14px;
        line-height: 2;
        `};

        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: center;
        color: #666666;
    }

    .complete-date {
        ${isMobileOnly?`
        font-size: 12px;
        line-height: 1.33;
        `:`
        font-size: 14px;
        line-height: 2;
        `};

        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #999999;
    }
`;

const EsOrderDoneDePositBlock = styled.div`
    ${isMobileOnly?`
    padding: 30px 0 0px;
    `:`
    padding: 60px 0 0px;
    `};

    .price-deposit {
        font-weight: 600;
    }

`;
const EsOrderDoneDeliveryBlock = styled.div`
    ${isMobileOnly?`
    padding: 30px 0 0px;
    `:`
    padding: 60px 0 0px;
    `};

    .gray-block {
        ${isMobileOnly?`
        font-size: 12px;
        line-height: 1.4;
        padding: 10px 0;
        `:`
        height: 51px;
        font-size: 13px;
        line-height: 1.31;
        padding: 17px 0;
        `};

        background-color:#f4f4f4;
        
        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: center;
        color:#999999;
        
    }
`;

const EsOrderDoneItemsBlock = styled.div`
    ${isMobileOnly?`
    padding: 30px 0 0px;
    `:`
    padding: 60px 0 0px;
    `};

    .right-text {
        ${isMobileOnly?`
        padding: 0 0px;
        font-size: 13px;
        line-height: 1.46;
        `:`
        padding: 20px 0;
        font-size: 14px;
        line-height: 1.57;
        `};
        
        font-weight: 500;
        color: #999999;
        float: right;
        
        .num {
            font-weight: 600;
        }
    }

    .container2-content {
        padding: 0 11px 0 12px;
    }
`;

const EsOrderDonePayBlock = styled.div`
    ${isMobileOnly?`
    padding: 30px 0 0px;
    `:`
    padding: 60px 0 0px;
    `};

    .container3-content {
        border: solid 1px #111111;
        border-bottom-left-radius: 20px;
    }

    .border-r {
        border-right: solid 1px #cccccc;
    }

    .border-b {
        border-bottom: dotted 1px #cccccc;
    }
`;

const EsOrderDonePayBottomBlock = styled.div`
    position: relative;
    float: left;
    min-width: 150px;
    //min-height: 130px;
    padding: 20px 10px;
    //border-radius: 65px;
    //background-color: #e0e0e0;
    text-align: center;
    width: 294px;
    min-height: 58px;

    &.minus-icon::after {
    top: 46%;
    right: -10px;
    width: 20px;
    height: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1;
    }

    &.plus-icon::after {
        top: 46%;
        right: -10px;
        width: 20px;
        height: 20px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1;
        }

    &.equal-icon::after {
        top: 46%;
        right: -10px;
        width: 20px;
        height: 20px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1;
      }

      .small {
        font-size: 14px;
        color: #666666;
        line-height: 1.2;
        margin: 0;
        height: 0px;
    }

    .ex_delivery {
        ${isMobileOnly?`
        font-size: 12px;
        `:`
        font-size: 14px;
        `};

        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: right;
        color: #666666;

        .price {
            font-weight: 500;
            color: #333333;
            position: relative;
            display: inline-block;
            ::after {
                content: '';
                display: block;
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 4px;
                height: 12px;
                background-color: #ffe7ad;
                z-index: -1;
            }
        }
    }

    .last-price {
        font-weight: bold;
    }
`;

const EsOrderDonePayBottomTitleBlock = styled.div`
    line-height: 1.2;
    display: block;
    margin-bottom: 10px;
    color: #111111;
    font-size: 14px;
    font-weight: 500;
    text-align:center;
    height: 20px;

`;

const EsOrderDonePayBottomPriceBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 10px;
    float: left;
    `:`
    height: 27px;
    line-height: 1.2;
    `};

`;

const EsOrderDoneInfoBlock = styled.div`
    ${isMobileOnly?`
    padding: 20px;
    margin-top: 30px;
    `:`
    padding: 20px 0;
    margin-top: 60px;
    `};

    //padding: 60px 0 0px;
    border-radius: 4px;
    background-color:#f4f4f4;
    
    

    color: #333333;
    font-size: 14px;

    .fa-exclamation-circle:before {
        content: "\f06a";
    }
    //content: "\f06a";

    .left-confrim {
        ${isMobileOnly?`
        
        `:`
        line-height: 78px;
        margin-left: 64px;
        margin-right: 80px;
        `};
        font-weight: 500;
        
        position: relative;
        ::before {
            content: '';
            display: inline-block;
            width: 16px;
        height: 16px;
        margin-right: 14px;
        object-fit: contain;
        background: url(/assets/images/icon/exclamation.svg) center center/auto no-repeat;
        vertical-align: -3px;
        }
        
    }
    
    .right-text {
        font-weight: normal;
        line-height: 1.86;
        ${isMobileOnly?`
        font-size: 12px;
        color: #666666;
        line-height: 1.83;
        `:`
        
        `};
    }
`;

const EsOrderDoneBottomBlock = styled.div`
    ${isMobileOnly?`
    margin: 20px 0;
    `:`
    margin-top: 60px;
    `};
    

    .pay_done_btn-wrap2 {
        text-align: center;
    }

    .mh-btn2 {
        ${isMobileOnly?`
        font-size: 13px;
        padding: 0 20px;
        margin: 10px 0;
        `:`
        font-size: 16px;
        padding: 0 30px;
        `};
        display: inline-block;
        //min-width: 110px;
        line-height: 40px;
        
        color: #fff;
        background-color: #333;
        border-radius: 20px;
        text-align: center;
        vertical-align: 10px;
        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
    }

    .gray-btn2 {
        ${isMobileOnly?`
        margin-right: 5px;
        `:`
        margin-right: 15px;
        `};
        color: #333333;
        background-color: #ececec;
        border: 1px solid #ececec;
        
    }

    .black-btn2 {
        ${isMobileOnly?`
        margin-left: 5px;
        `:`
        margin-left: 15px;
        `};
        color: #ffffff;
        background-color: #111111;
        border: 1px solid #111111;
        
    }
`;

const EsOrderMobilePayBlock = styled.div`
    margin-top: 30px;

    .checkblock {
        margin-right: 7px;
        float : left;
        margin-top: -4px;
    }

    .check_text {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.69;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }
`;

const EsOrderRightPayBlock = styled.div`
    ${isMobileOnly?`
    padding: 0px 10px;
         
    `:`
    width: 352px;
    padding: 30px 20px 30px 20.6px;
    border: solid 1px #111111;
    border-bottom-left-radius: 20px;
    `};

    .pay_wrap {
        height: 24px;
        margin-bottom: 20px;
    }

    .pay_wrap2 {
        ${isMobileOnly?`
        height: 18x;
        `:`
        fheight: 24px;
        `};

        margin-bottom: 6px;
    }

    .total_text {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }

    .total_price {
        ${isMobileOnly?`
        font-size: 16px;
        line-height: 1.25;
        `:`
        font-size: 18px;
        line-height: 1.33;
        `};
        
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: right;
        color: #111111;
        float: right;
    }

    .sale {
        color: #79b88a;
    }

    .last {
        font-weight: bold;
    }

    .last_price {
        ${isMobileOnly?`
        font-size: 18px;
        line-height: 1.11;
        `:`
        font-size: 32px;
        line-height: 0.75;
        `};
        
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: right;
        color: #111111;
    }

    .checkblock {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`
        margin-right: 7px;
        `};
        float : left;
        margin-top: -4px;
    }

    .check_text {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.69;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }

    .btn_pay {
        padding: 14.4px 120.7px 16.6px 116.3px;
        border-radius: 4px;
        background-color: #ffc742;
        width: 311px;
        height: 60px;

        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #111111;
    }

    .pay-line {
        height: 1px;
        border-bottom: dashed 1px #cccccc;
    }

    .won {
        ${isMobileOnly?`
        font-size: 14px;
        `:`
        font-size: 16px;
        `};
        
        font-weight: normal;
    }

    .ex_delivery {
        ${isMobileOnly?`
        font-size: 12px;
        `:`
        font-size: 14px;
        `};

        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: right;
        color: #666666;

        .price {
            font-weight: 500;
            color: #333333;
            position: relative;
            display: inline-block;
            ::after {
                content: '';
                display: block;
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 4px;
                height: 12px;
                background-color: #ffe7ad;
                z-index: -1;
            }
        }
    }
`;

const EsOrderDoneBlankBlock = styled.div`
    height: 1px;
`;
/**
 * 주문완료 페이지 
 * @param {*} param0 
 */
const EsOrderDoneMulti = ({ location }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [reqCnt, setReqCnt] = useState(0);
    const [itemBrList, setItemBrList] = useState([]);
    const [prdductPrice, setProductPrice] = useState(0); //총 상품 금액
    const [dscPrice, setDscPrice] = useState(0);       // 총 할인 금액
    const [esDscPrice, setEsDscPrice] = useState(0);  //견적 할인 금액
    const [dvrPrice, setDvrPrice] = useState(0);        //배송비
    const [dvrAfterPrice, setDvrAfterPrice] = useState(0);        //착불배송비
    const [totalLastPrice, setTotalLastPrice] = useState(0);    //최종 결재 금액

    const { esOrderInfo, accessToken, curMenu, error } = useSelector(
        ({ userReducer, esOrderReducer, headerReducer }) => ({
            accessToken: userReducer.accessToken,
            esOrderInfo: esOrderReducer.esOrderInfo,
            curMenu: headerReducer.curMenu,
            error: esOrderReducer.error
        })
    );

    useEffect(() => {

        if (curMenu !== 'oddone') {
            dispatch(setCurMenuAction('oddone'));
            dispatch(setHeaderTransferAction(false));
            window.scrollTo(0, 0);
        }

        if (accessToken === null || location.search === null
            || location.search === undefined) {
            history.push("/notfound");
        }
    });

    useEffect(() => {

        if (error !== null) {
            // TODO : 오류 발생시 에는 오류 페이지 표시 
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if ((esOrderInfo !== null && esOrderInfo.code === 500)) {
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if ((esOrderInfo !== null && esOrderInfo.code === 600)) {
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if (esOrderInfo === null && reqCnt < 5) {
            setReqCnt(reqCnt + 1);
            dispatch(reqEsOrderInfoAction(location.search));
        } else if (esOrderInfo !== null && esOrderInfo.code === 200) {
            
            let esItemInfo = null;
            if(esOrderInfo.data !== null && esOrderInfo.data !== undefined && esOrderInfo.data.items !== null && esOrderInfo.data.items !== undefined) {
                esItemInfo = esOrderInfo.data;
            }

            if (esItemInfo === null) {
                return;
            }

            if(esItemInfo !== null && esItemInfo !== undefined && esItemInfo.items !== null && esItemInfo.items !== undefined && esItemInfo.items.length > 0) {
    
                let tmpList = [];
                if(esItemInfo.items !== null && esItemInfo.items.length > 0) {
                    let resGrpJson = groupBy(esItemInfo.items, (item) => {
                        return item.es_rqst_id;
                    });
        
                    forEach(resGrpJson, (value, key) => {
                        let tmpItem = { 'es_rqst_id': key, 'list': value };
    
                        tmpList.push(tmpItem);
                    })
    
                    //console.log("tmpList = " + JSON.stringify(tmpList))
                    setItemBrList(tmpList);
                }
    
                let _prdductPrice = 0;//총 상품 금액
                let _dscPrice = 0;// 총 할인 금액
                let _esDscPrice = 0;//견적 할인 금액
                let _dvrPrice = 0;//배송비
                let _dvrAfterPrice = 0;//착불배송비
                let _totalLastPrice = 0;//최종 결재 금액
    
                forEach(tmpList, (item, index) => {
    
                    _prdductPrice = _prdductPrice + item.list[0].es_prdct_total_price;
                    _dscPrice = _dscPrice + item.list[0].es_dscnt_total_price;
                    _esDscPrice = _esDscPrice + item.list[0].es_dscnt_total_price;
                    _totalLastPrice = _totalLastPrice + item.list[0].es_final_price;
    
                    if (item.list[0].es_dlvry_final_pay_type === '025201') { //선불
                        _dvrPrice = _dvrPrice + item.list[0].es_dlvry_total_price;
                    } else if (item.list[0].es_dlvry_final_pay_type === '025202') { // 착불
                        _dvrAfterPrice = _dvrAfterPrice + item.list[0].es_dlvry_total_price;
                    } else {
                        
                    }
    
                });
    
                _totalLastPrice = _totalLastPrice + _dvrPrice;
                setProductPrice(_prdductPrice);
                setDscPrice(_dscPrice);
                setEsDscPrice(_esDscPrice);
                setDvrPrice(_dvrPrice);
                setDvrAfterPrice(_dvrAfterPrice);
                setTotalLastPrice(_totalLastPrice);
                
            }
        }

    }, [esOrderInfo, error])

    if (accessToken === null || (esOrderInfo !== null && esOrderInfo.code === 600)) {
        history.replace("/");
        dispatch(reqEsOrderCodeReset());
        return <div/>
    }

    if (esOrderInfo === null || esOrderInfo.data.orderinfo === null || esOrderInfo.data.orderinfo === undefined) {
        return <EsOrderDoneBlock />
    }


    const getMobileText = (phone) => {
        if (phone === null) {
            return "";
        }

        if (phone.length < 10) {
            return phone;
        }

        let mobile = getMobile(phone,1)+"."+getMobile(phone,2)+"."+getMobile(phone,3);
        //setOdMobile(mobile);

        return mobile;

    }


    const getMobile = (phone, param) => {

        if (phone === null) {
            return "";
        }

        if (phone.length < 10) {
            return phone;
        }

        let length = phone.length;
        let scndEnd = length - 4;

        if (param === 1) {
            return phone.substring(0, 3);
        } else if (param === 2) {
            return phone.substring(3, scndEnd);
        } else if (param === 3) {
            return phone.substring(scndEnd, length);
        } else {
            return "";
        }
    }

    const getPayDate = () => {
        if(esOrderInfo === null || esOrderInfo.data.orderinfo === undefined || esOrderInfo.data.orderinfo === null) {
            return "-"
        }
        if(esOrderInfo.data.orderinfo !== null && esOrderInfo.data.orderinfo !== undefined && 
            esOrderInfo.data.orderinfo.od_apply_date !== undefined && esOrderInfo.data.orderinfo.od_apply_date !== null) {
            return moment(esOrderInfo.data.orderinfo.od_apply_date).format('YYYY-MM-DD HH:mm')
        }
    }

    const getBootData = () => {
        
        if(esOrderInfo === null || esOrderInfo.data.bootpay === undefined || esOrderInfo.data.bootpay === null) {
            return "-"
        }
        if(esOrderInfo.data.bootpay !== null && esOrderInfo.data.bootpay !== undefined && 
            esOrderInfo.data.bootpay.payment_data !== undefined && esOrderInfo.data.bootpay.payment_data !== null) {
            let obj = JSON.parse(esOrderInfo.data.bootpay.payment_data);
            //console.log("paymet = " + JSON.stringify(obj))
            if(esOrderInfo.data.orderinfo.od_pay_type_code === '150401') {
                let reText = "";
                let month = "";
                let cardNum = "";
                if(obj.card_name !== undefined && obj.card_name !== null) {
    
                    if(obj.card_quota !== undefined && obj.card_quota !== null) {
                        let num = obj.card_quota*1;
                        if(num === 0) {
                            month = "/일시불";
                        } else {
                            month = "/" + num + "개월";
                        }
                    }
                    
                    if(obj.card_no !== undefined && obj.card_no !== null) {
                        cardNum = " " + obj.card_no;
                    }
                    reText = obj.card_name + month + cardNum;
                }
                return reText;
            } else if(esOrderInfo.data.orderinfo.od_pay_type_code === '150403') {
                return obj.bankname;
            }
            
        }

        return "-";
    }

    const gotoHome = () => {
        history.push("/");
    }

    const gotoEs = () => {
        //dispatch(setEsitemCurIdxAction(1));
        //history.replace("/es");
        history.replace("/es",{ index: 1 })
    }

    const isVbank = () => {
        if(esOrderInfo !== null && esOrderInfo !== undefined && esOrderInfo.data.orderinfo !== null 
            && esOrderInfo.data.orderinfo !== undefined && esOrderInfo.data.orderinfo.od_pay_type_code !== null 
            && esOrderInfo.data.orderinfo.od_pay_type_code !== undefined) {
                return (esOrderInfo.data.orderinfo.od_pay_type_code === '150402');
            }
        
            return false;
    }

    const headerVbankAdd = () => {
        if(isVbank()) {
            return <div className="complete-sub margin_b-20">선택하신 은행으로 입금해주세요.</div>
        }
    }

    const depositBlock = () => {
        if(isVbank()) {
           return(isMobileOnly?
                <EsOrderDoneDePositBlock>
                    <div className="header">입금 정보 </div>
                    <div className="container-content">
                        <div className="margin_b-20 clearfix"><div className="sub-title">입금금액</div><div className="sub-content"><span className="price-deposit">{Number(esOrderInfo.data.orderinfo.od_pay_price.toFixed(1)).toLocaleString()}</span>원 </div></div>
                        <div className="margin_b-20 clearfix"><div className="sub-title">입금계좌</div><div className="sub-content">{esOrderInfo.data.orderinfo.od_vbank_name}&nbsp;&nbsp;  {esOrderInfo.data.orderinfo.od_vbank_account}</div></div>
                        <div className="margin_b-20 clearfix"><div className="sub-title">예금주</div><div className="sub-content">주식회사 마인드그룹</div></div> 
                        <div className="margin_b-30 clearfix"><div className="sub-title">입금기한</div><div className="sub-content">{esOrderInfo.data.orderinfo.od_vbank_expiredate}</div></div>
                    </div>
                    <EsOrderDoneHeaderGrayLine/>
                </EsOrderDoneDePositBlock>
            :
                <EsOrderDoneDePositBlock>
                    <div className="header">입금 정보 </div>
                    <div className="line"></div>
                    <div className="container-content">
                        <div className="margin_b-10"><span className="sub-title">입금금액</span><span className="sub-content"><span className="price-deposit">{Number(esOrderInfo.data.orderinfo.od_pay_price.toFixed(1)).toLocaleString()}</span>원 </span></div>
                        <div className="margin_b-10"><span className="sub-title">입금계좌</span><span className="sub-content">{esOrderInfo.data.orderinfo.od_vbank_name}&nbsp;&nbsp; {esOrderInfo.data.orderinfo.od_vbank_account}</span></div>
                        <div className="margin_b-10"><span className="sub-title">예금주</span><span className="sub-content">주식회사 마인드그룹</span></div>
                        <div className="margin_b-30"><span className="sub-title">입금기한</span><span className="sub-content">{esOrderInfo.data.orderinfo.od_vbank_expiredate}</span></div>
                    </div>
                    <div className="line2"></div>
                </EsOrderDoneDePositBlock>
           ) 
        }

    }

    const handleBack = () => {
        history.goBack();
    }

    const payMethodBlock = () => {
        if(!isVbank()){
            return (isMobileOnly?
                <EsOrderDoneDeliveryBlock>
                <div className="header">결제 수단</div>
                <div className="container-content">
                    <div className="margin_b-20 clearfix"><div className="sub-title">결제방법</div><div className="sub-content">{esOrderInfo.data.orderinfo.od_pay_type} {Number(totalLastPrice.toFixed(1)).toLocaleString()}원</div></div>
                    <div className="margin_b-20 clearfix"><div className="sub-title">결제정보</div><div className="sub-content">{getBootData()}</div></div>
                    <div className="margin_b-30 clearfix"><div className="sub-title">결제일시</div><div className="sub-content">{getPayDate()}</div></div>
                </div>
                <EsOrderDoneHeaderGrayLine/>
                </EsOrderDoneDeliveryBlock>
                :
                <EsOrderDoneDeliveryBlock>
                <div className="header">결제 수단</div>
                <div className="line"></div>
                <div className="container-content">
                    <div className="margin_b-10"><span className="sub-title">결제방법</span><span className="sub-content">{esOrderInfo.data.orderinfo.od_pay_type} {Number(totalLastPrice.toFixed(1)).toLocaleString()}원</span></div>
                    <div className="margin_b-10"><span className="sub-title">결제정보</span><span className="sub-content">{getBootData()}</span></div>
                    <div className="margin_b-30"><span className="sub-title">결제일시</span><span className="sub-content">{getPayDate()}</span></div>
                </div>
                <div className="line2"></div>
                </EsOrderDoneDeliveryBlock>
            )
        }
    }
    return (
        <EsOrderDoneBlock>
            {!isMobileOnly&&<Header />}
            {isMobileOnly?
                <EsOrderDoneContentsBlock>
                    {isMobileOnly&&<EsOrderDoneHeaderTitleMBlock><EsOrderDoneHeaderTitleMBtnBlock onClick={handleBack}/>주문 완료</EsOrderDoneHeaderTitleMBlock>}
                    <EsOrderDoneHeaderBlock className="">
                        <div className="complete-icon"></div>
                        <div className="complete-title margin_t-20 margin_b-10"><span className="green">주문이 완료</span>되었어요.</div>
                        {headerVbankAdd()}
                        <div className="complete-num">No.{esOrderInfo.data.orderinfo.od_id}</div>
                        <div className="complete-date margin_b-50" >({esOrderInfo.data.orderinfo.od_reg_date})</div>
                        <EsOrderDoneHeaderGrayLine/>
                    </EsOrderDoneHeaderBlock>
                    
                    {depositBlock()}

                    <EsOrderDoneDeliveryBlock>
                    <div className="header">배송 정보 </div>
                    {/* <div className="line"></div> */}
                    <div className="container-content">
                        <div className="margin_b-20 clearfix"><div className="sub-title">수령인</div><div className="sub-content">{esOrderInfo.data.orderinfo.rv_nm}</div></div>
                        <div className="margin_b-20 clearfix"><div className="sub-title">배송주소</div><div className="sub-content">[{esOrderInfo.data.orderinfo.rv_addrzip}] {esOrderInfo.data.orderinfo.rv_addr1}, {esOrderInfo.data.orderinfo.rv_addr2}</div></div>
                        <div className="margin_b-20 clearfix"><div className="sub-title">연락처</div><div className="sub-content">{getMobileText(esOrderInfo.data.orderinfo.rv_mo_no)}
                        {getMobileText(esOrderInfo.data.orderinfo.rv_mo_no2).length > 0? " / " + getMobileText(esOrderInfo.data.orderinfo.rv_mo_no2): ''}</div></div>
                        {esOrderInfo.data.orderinfo.od_dlvry_memo!==null && esOrderInfo.data.orderinfo.od_dlvry_memo.length>0 &&<div className="margin_b-20 clearfix"><div className="sub-title">배송요청사항</div><div className="sub-content">{esOrderInfo.data.orderinfo.od_dlvry_memo}</div></div>}
                        <div className="gray-block margin_b-30">*도서산간 지역의 경우 추후 수령 시<p> 추가배송비가 과금 될 수 있습니다.</p></div>
                    </div>
                    {/* <div className="line2"></div> */}
                    <EsOrderDoneHeaderGrayLine/>
                    </EsOrderDoneDeliveryBlock>

                    <EsOrderDoneItemsBlock>
                        <div className="header">주문 상품 정보 <span className="right-text">견적서 <span className="num">{itemBrList.length}</span>건</span></div>
                        {/* <div className="line"></div> */}
                        <div className="">
                        <EsOrderDoneList itemBrList={itemBrList} isEsInfo={false} orderinfo={esOrderInfo.data.orderinfo}/>
                        </div>
                        <EsOrderDoneHeaderGrayLine className="margin_t-10"/>
                    </EsOrderDoneItemsBlock>
                    
                    {payMethodBlock()}
                    <EsOrderMobilePayBlock>
                        <div className="header margin_b-30">결제 상세 내역</div>
                        <EsOrderRightPayBlock>
                            <div className="margin_b-16" ><span className="total_text">총 상품 금액</span><span className="total_price">{Number(prdductPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                            <div className="margin_b-16 pay-line"></div>
                            <div className="pay_wrap2" ><span className="total_text">총 할인 금액</span><span className="total_price">{Number(dscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                            <div className="margin_b-16" ><span className="total_text sale">- 견적 할인</span><span className="total_price sale">{Number(esDscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                            <div className="margin_b-16 pay-line"></div>
                            <div className="margin_b-16" ><span className="total_text">배송비</span><span className="total_price">{Number(dvrPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                            <div className="line-no-margin margin_b-16 "></div>
                            <div className="margin_b-10"><span className="total_text last">최종 결제 금액</span><span className="total_price last_price">{Number(totalLastPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                            {dvrAfterPrice>0&&<div ><p className="ex_delivery">예상 착불 배송비는 <div className="price"><span>{Number(dvrAfterPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>입니다.</p></div>}
                            {dvrAfterPrice>0&&<div className="margin_b-30" ><p className="ex_delivery">미리 준비해주세요.</p></div>}
                            {dvrAfterPrice===0&&<div className="margin_b-30" ><p className="ex_delivery"></p></div>}
                        </EsOrderRightPayBlock>
                        <EsOrderDoneHeaderGrayLine className="margin_t-10 margin_b-30"/>
                    </EsOrderMobilePayBlock>

                    <EsOrderDoneInfoBlock className="clearfix">
                        <div>
                            <div className="left-confrim margin_b-10">확인해주세요.</div>
                            <div className="right-text ">
                                <div>• 결제, 배송 정보는 이메일로 확인하실 수 있습니다.</div>
                                <div>• 주문관련 문의는 고객센터 혹은 1:1문의를 이용바랍니다.</div>
                                <div>• 주문내역은 [가구견적] > [주문완료견적서] 에서 확인하실 수 있습니다.</div>
                            </div>
                        </div>
                    </EsOrderDoneInfoBlock>

                    <EsOrderDoneBottomBlock>
                    <div className="pay_done_btn-wrap2">
                        <button className="mh-btn2 gray-btn2" onClick={gotoEs}>주문 견적서 조회</button>
                        <button className="mh-btn2 black-btn2" onClick={gotoHome}>쇼핑 계속하기</button>
                            {/* <a href="/" className="mh-btn gray-btn">홈 이동</a> */}
                            {/* <a href="/es" className="mh-btn black-btn margin_l-30">가구 견적 이동</a> */}
                        </div>
                    </EsOrderDoneBottomBlock>

                </EsOrderDoneContentsBlock >
            :
                <EsOrderDoneContentsBlock>
                {isMobileOnly&&<EsOrderDoneHeaderTitleMBlock><EsOrderDoneHeaderTitleMBtnBlock onClick={handleBack}/>주문 완료</EsOrderDoneHeaderTitleMBlock>}
                <EsOrderDoneHeaderBlock>
                    <div className="complete-icon"></div>
                    <div className="complete-title margin_t-30 margin_b-20"><span className="green">주문이 완료</span>되었어요.</div>
                    {headerVbankAdd()}
                    <div className="complete-num">No.{esOrderInfo.data.orderinfo.od_id}</div>
                    <div className="complete-date">({esOrderInfo.data.orderinfo.od_reg_date})</div>
                </EsOrderDoneHeaderBlock>
                {depositBlock()}
                <EsOrderDoneDeliveryBlock>
                <div className="header">배송 정보 </div>
                <div className="line"></div>
                <div className="container-content">
                    <div className="margin_b-10"><span className="sub-title">수령인</span><span className="sub-content">{esOrderInfo.data.orderinfo.rv_nm}</span></div>
                    <div className="margin_b-10"><span className="sub-title">배송주소</span><span className="sub-content">[{esOrderInfo.data.orderinfo.rv_addrzip}] {esOrderInfo.data.orderinfo.rv_addr1}, {esOrderInfo.data.orderinfo.rv_addr2}</span></div>
                    <div className="margin_b-10"><span className="sub-title">연락처</span><span className="sub-content">{getMobileText(esOrderInfo.data.orderinfo.rv_mo_no)}
                    {getMobileText(esOrderInfo.data.orderinfo.rv_mo_no2).length > 0? " / " + getMobileText(esOrderInfo.data.orderinfo.rv_mo_no2): ''}</span></div>
                    {esOrderInfo.data.orderinfo.od_dlvry_memo!==null && esOrderInfo.data.orderinfo.od_dlvry_memo.length>0 ?<div className="margin_b-20"><span className="sub-title">배송요청사항</span><span className="sub-content">{esOrderInfo.data.orderinfo.od_dlvry_memo}</span></div>:<EsOrderDoneBlankBlock className="margin_b-10" />}
                    <div className="gray-block margin_b-30">*도서산간 지역의 경우 추후 수령 시 추가배송비가 과금 될 수 있습니다.</div>
                </div>
                <div className="line2"></div>
                </EsOrderDoneDeliveryBlock>
                    
                <EsOrderDoneItemsBlock>
                    <div className="header">주문 상품 정보 <span className="right-text">견적서 <span className="num">{itemBrList.length}</span>건</span></div>
                    <div className="line"></div>
                    <div className="container2-content">
                    <EsOrderDoneList itemBrList={itemBrList} isEsInfo={false} orderinfo={esOrderInfo.data.orderinfo}/>
                    </div>
                </EsOrderDoneItemsBlock>

                <EsOrderDonePayBlock>
                    <div className="header">결제 상세 내역</div>
                    {/* <div className="line"></div> */}
                    <div className="container3-content clearfix">
                        <div style={{ display: 'flex', justifyContent: 'center', width:'1176px', float:'left'}}>

                                            
                            <EsOrderDonePayBottomBlock className="minus-icon border-r border-b">
                                <EsOrderDonePayBottomTitleBlock>총 상품 금액</EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock>
                                    {
                                    F.showAmount({amount:prdductPrice, fontSize:"22px", color:"#333333", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                                    }
                                    
                                </EsOrderDonePayBottomPriceBlock>
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock className="plus-icon border-r border-b">
                                <EsOrderDonePayBottomTitleBlock>총 할인 금액</EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock>
                                    {
                                    F.showAmount({amount:dscPrice, fontSize:"22px", color:"#333333", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                                    }
                                </EsOrderDonePayBottomPriceBlock>
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock className="equal-icon border-r border-b">
                                <EsOrderDonePayBottomTitleBlock>배송비</EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock>
                                    {
                                    F.showAmount({amount:dvrPrice, fontSize:"22px", color:"#333333", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                                    }
                                    
                                </EsOrderDonePayBottomPriceBlock>
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock className="border-b">
                                <EsOrderDonePayBottomTitleBlock className="last-price ">최종 결제 금액</EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock>
                                    {
                                    F.showAmount({amount:totalLastPrice, fontSize:"22px", color:"#fc1c67", weight:"500", unit:"원", falseVal:"0원",unitColor:"#333333", unitWeight:'normal',unitFontSize:"14px" })
                                    }
                                </EsOrderDonePayBottomPriceBlock>
                            </EsOrderDonePayBottomBlock>
                        </div>
                        <div className="clearfix" style={{ display: 'flex', justifyContent: 'center', width:'1176px', float:'left'}}>

                                            
                            <EsOrderDonePayBottomBlock className="border-r">
                                {/* <EsOrderDonePayBottomTitleBlock></EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock></EsOrderDonePayBottomPriceBlock> */}
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock className="border-r">
                                <EsOrderDonePayBottomTitleBlock className="f-left small">∙견적 할인</EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock className="f-right small">
                                    {
                                    F.showAmount({amount:esDscPrice, fontSize:"14px", color:"#666666", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                                    }
                                </EsOrderDonePayBottomPriceBlock>
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock className="border-r">
                                {/* <EsOrderDonePayBottomTitleBlock></EsOrderDonePayBottomTitleBlock>
                                <EsOrderDonePayBottomPriceBlock></EsOrderDonePayBottomPriceBlock> */}
                            </EsOrderDonePayBottomBlock>
                            <EsOrderDonePayBottomBlock>
                                {/* <EsOrderDonePayBottomTitleBlock></EsOrderDonePayBottomTitleBlock> */}
                                {dvrAfterPrice>0&&<div ><p className="ex_delivery">예상 착불 배송비는 <div className="price"><span>{Number(dvrAfterPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>입니다.</p></div>}
                                    {dvrAfterPrice>0&&<div className="" ><p className="ex_delivery">미리 준비해주세요.</p></div>}
                                {/* <EsOrderDonePayBottomPriceBlock></EsOrderDonePayBottomPriceBlock> */}
                            </EsOrderDonePayBottomBlock>
                        </div>
                    </div>
                </EsOrderDonePayBlock>
                {payMethodBlock()}

                <EsOrderDoneInfoBlock className="clearfix">
                    <div>
                        <div className="left-confrim f-left">확인해주세요.</div>
                        <div className="right-text f-left">
                            <div>• 결제, 배송 정보는 이메일로 확인하실 수 있습니다.</div>
                            <div>• 주문관련 문의는 고객센터 혹은 1:1문의를 이용바랍니다.</div>
                            <div>• 주문내역은 [가구견적] > [주문완료견적서] 에서 확인하실 수 있습니다.</div>
                        </div>
                    </div>
                </EsOrderDoneInfoBlock>

                <EsOrderDoneBottomBlock>
                <div className="pay_done_btn-wrap2">
                    <button className="mh-btn2 gray-btn2" onClick={gotoEs}>주문 견적서 조회</button>
                    <button className="mh-btn2 black-btn2" onClick={gotoHome}>쇼핑 계속하기</button>
                        {/* <a href="/" className="mh-btn gray-btn">홈 이동</a> */}
                        {/* <a href="/es" className="mh-btn black-btn margin_l-30">가구 견적 이동</a> */}
                    </div>
                </EsOrderDoneBottomBlock>

            </EsOrderDoneContentsBlock >
            }
            
            <Footer />
        </EsOrderDoneBlock >
    );
};

export default EsOrderDoneMulti;